export const CREATE_CART = /* GraphQL */ `
  mutation createCart($input: CreateCartInput!) {
    createCart(input: $input) {
      createdAt
      saddleId
      horseId
      score
      updatedAt
      userId
      productData {
        pk
        sk
        type
        brandName
        createdAt
        discipline
        manufacturerMeasurements {
          gulletWidth
          gulletHeight
          barAngle
        }
        measurements {
          gulletWidth
          gulletHeight
          barAngle
        }
        newOrUsed
        price
        photo
        productTitle
        gallery
        quantity
        size
        status
        description
        score
        updatedAt
        variantId
        userId
      }
    }
  }
`;

export const DELETE_CART = /* GraphQL */ `
  mutation deleteCart($input: DeleteCartInput!) {
    deleteCart(input: $input) {
      id
    }
  }
`;
